import SmartStartV2Page from '../components/SmartStart/v2/SmartStartV2Page';

export default SmartStartV2Page;
